import { render, staticRenderFns } from "./FormSubmitSuccessIndicator.vue?vue&type=template&id=24222913&scoped=true"
import script from "./FormSubmitSuccessIndicator.vue?vue&type=script&lang=js"
export * from "./FormSubmitSuccessIndicator.vue?vue&type=script&lang=js"
import style0 from "./FormSubmitSuccessIndicator.vue?vue&type=style&index=0&id=24222913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24222913",
  null
  
)

export default component.exports